import { observable, computed, autorun, toJS } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { noop } from '@src/utils/common-util';
import { useEffect } from 'react';
import $$tracker from '@src/tracker';

class AudioListStore {
  audioListSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      slidesPerView: 1,
      spaceBetween: 0
    }
  });

  paginationSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      slidesPerView: 4,
      centeredSlides: true
    }
  });

  onSelect = noop;

  @observable currentPageNum = 0;
  // 音频列表
  @observable audioList = [];
  // 当前选中的音频索引
  @observable activeIndex = 0;
  // 当前选中的音频
  @computed
  get activeAudio() {
    return this.audioList[this.activeIndex];
  }

  formatDuration = seconds => {
    if (!seconds) {
      return '00:00';
    } else {
      return seconds.toString();
    }
    // const mins = Math.floor(seconds / 60);
    // const secs = Math.floor(seconds % 60);
    // return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // formatDuration = item => {
  //   console.log(item);
  //   let formattedDuration = '00:00';
  //   /**
  //    * 计算音频时长
  //    */
  //   const file = item.audioUrl;
  //
  //   // 创建音频元素来获取时长
  //   const audio = new Audio(file);
  //
  //   // 监听元数据加载完成事件
  //   audio.addEventListener('loadedmetadata', () => {
  //     // 获取音频时长（秒）
  //     const duration = audio.duration;
  //     console.log(`音频时长: ${duration} 秒`);
  //
  //     // 如果需要格式化为分:秒格式
  //     const minutes = Math.floor(duration / 60);
  //     const seconds = Math.floor(duration % 60);
  //     formattedDuration = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  //     console.log(`格式化时长: ${formattedDuration}`);
  //
  //     //可以在这里将时长存储到状态中
  //     item.duration = formattedDuration;
  //   });
  //
  //   // 错误处理
  //   audio.addEventListener('error', e => {
  //     console.error('加载音频失败:', e);
  //   });
  // };

  select(index) {
    // if (this.activeIndex !== index) {
    //   this.activeIndex = index;
    //   this.onSelect(toJS(this.activeAudio), index);
    // }
    // const currentIndex = this.audioListSwiperStore.activeIndex * 6 + index;
    // console.log('currentIndex', currentIndex);
    // console.log(this.audioList[this.activeIndex]);
    // console.log(index);
    if (this.activeIndex !== index) {
      // 比较全局索引
      this.activeIndex = index;
      this.onSelect(toJS(this.activeAudio), index);
    }
  }

  togglePageNum(index) {
    this.currentPageNum = index;

    this.paginationSwiperStore.onChange(index);
    this.audioListSwiperStore.onChange(index);
  }

  prevPage() {
    if (this.currentPageNum > 0) {
      this.togglePageNum(this.currentPageNum - 1);
    }
  }

  nextPage() {
    if (this.currentPageNum < Math.ceil(this.audioList.length / 6) - 1) {
      this.togglePageNum(this.currentPageNum + 1);
    }
  }

  constructor(props = {}) {
    Object.assign(this, props);
    this.onSelect = props.onSelect || noop;
  }

  use() {
    useMount(() => {
      const dispose = autorun(() => {
        this.togglePageNum(this.audioListSwiperStore.activeIndex);
      });

      return () => {
        dispose();
      };
    });
    useEffect(
      () => {
        if (this.activeAudio) {
          $$tracker.clickStzxMusic(this.activeAudio.title);
        }
      },
      [this.activeAudio]
    );
  }
}

export default AudioListStore;
